import { useState, useEffect } from 'react'

import { appointmentService } from '../services'

const appointmentDefault = ''

const useAppointments = (option: 'SUMMARYUPCOMINGS' | 'SUMMARYALL' | 'UPCOMINGS' | 'ALL' | 'DOCUMENTS' = 'ALL', patientId?: string) => {
  const [data, setData] = useState<any | ''>(appointmentDefault)

  useEffect(() => {
    if (option === 'SUMMARYUPCOMINGS') getSummary('SUMMARYUPCOMINGS')
    else if (option === 'SUMMARYALL') getSummary()
    else if (option === 'UPCOMINGS') get('UPCOMINGS', patientId)
    else if (option === 'ALL') get('ALL', patientId)
    else if (option === 'DOCUMENTS') getDocuments()
  }, [option, patientId])

  const getSummary = async (option: 'SUMMARYUPCOMINGS' | 'SUMMARYALL' = 'SUMMARYALL') => {
    let resp: any

    if(option === 'SUMMARYUPCOMINGS') resp = await appointmentService.getSummaryUpcomings()
    else if(option === 'SUMMARYALL') resp = await appointmentService.getSummaryAll()

    setData(resp.data)
  }

  const get = async (option: 'UPCOMINGS' | 'ALL' = 'ALL', patientId?: string) => {
    let resp: any

    if(patientId) setData(appointmentDefault)

    if(option === 'UPCOMINGS') resp = await appointmentService.getUpcomings(patientId)
    else if(option === 'ALL') resp = await appointmentService.getAll(patientId)

    setData(resp.data)
  }

  const getDocuments = async () => {
    const resp = await appointmentService.getDocuments()
    setData(resp.data)
  }

  return {
    data,
    getSummary,
    get,
    getDocuments
  }
}

export { useAppointments }